import React from "react";
import FieldDetails from "./FieldDetails";
import { useForm } from "react-hook-form";

const FormData = () => {
    const { register, errors, getValues } = useForm({
        defaultValues: {
            fields: {
                name: {
                    type: "text",
                    label: "Name",
                    required: true,
                    fieldName: "name",
                },
                agreement: {
                    type: "checkbox",
                    label: " Agree",
                    required: false,
                    fieldName: "agreement",
                },
            },
        },
    });

    const [formData, setFormData] = React.useState({
        name: {
            type: "text",
            label: "Name",
            required: true,
            fieldName: "name",
        },
        agreement: {
            type: "checkbox",
            label: " Agree",
            required: false,
            fieldName: "agreement",
        },
    });

    const updateFormData = (newFormData) => {
        setFormData(newFormData);
    };

    return (
        <form>
            {Object.entries(formData).map(([fieldKey, field]) => (
                <FieldDetails
                    key={fieldKey}
                    control={field}
                    updateFormData={updateFormData}
                    formData={formData}
                    fieldKey={fieldKey}
                    register={register}
                    errors={errors}
                    getValues={getValues}
                />
            ))}
            {/* Add submit button or other controls as needed */}
        </form>
    );
};

export default FormData;
